import { render, staticRenderFns } from "./RepList.vue?vue&type=template&id=64b51ade"
import script from "./RepList.vue?vue&type=script&lang=js"
export * from "./RepList.vue?vue&type=script&lang=js"
import style0 from "./RepList.vue?vue&type=style&index=0&id=64b51ade&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports